// extracted by mini-css-extract-plugin
export var discard = "_1v-4";
export var muiTooltipTooltip = "_1v-6";
export var notificationBar = "_1v-3";
export var notificationContainer = "_1v-2";
export var saveButtonHoverSlotWrapper = "_1v-5";
export var show = "_1v-1";
export var spacer = "_1v-0";